import React, { createContext, useState, useCallback } from "react";

export const VisualSearchContext = createContext(null);

const useVisualSearch = () => {
    const [visualSearchState, setVisualSearchState] = useState({
        photo: null,
        results: {},
        isLoading: false,
        isError: false,
        isUploadedImage: false,
        conversationId: null,
        sourcePath: null  // Add path tracking
    });

    const saveVisualSearchState = useCallback((state) => {
        setVisualSearchState(prevState => ({
            ...prevState,
            ...state
        }));
    }, []);

    const clearVisualSearchState = useCallback(() => {
        setVisualSearchState({
            photo: null,
            results: {},
            isLoading: false,
            isError: false,
            isUploadedImage: false,
            conversationId: null,
            sourcePath: null  // Clear path when clearing state
        });
    }, []);

    return {
        visualSearchState,
        saveVisualSearchState,
        clearVisualSearchState,
    };
};

const VisualSearchProvider = ({ children }) => {
    const visualSearch = useVisualSearch();

    return (
        <VisualSearchContext.Provider value={visualSearch}>
            {children}
        </VisualSearchContext.Provider>
    );
};

export default VisualSearchProvider;
